import { z } from 'zod';

export const OperatorRole = z.enum(['super_admin', 'admin', 'viewer']);
export type OperatorRole = z.infer<typeof OperatorRole>;

export const LoginRequest = z.strictObject({
  email: z.string().trim().toLowerCase().min(1).max(254),
  password: z.string().min(1).max(1024),
});
export type LoginRequest = z.input<typeof LoginRequest>;

/** The signed-in operator as the API returns it (dates as ISO strings). */
export const Operator = z.object({
  id: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  role: OperatorRole,
  lastLoginAt: z.string().nullable(),
  features: z.array(z.string()).nullable(),
});
export type Operator = z.infer<typeof Operator>;

/** The session itself is the httpOnly cookie set alongside. */
export const LoginResponse = z.object({ success: z.literal(true), user: Operator });
export type LoginResponse = z.infer<typeof LoginResponse>;

export const ProfileResponse = z.object({ success: z.literal(true), user: Operator });
export type ProfileResponse = z.infer<typeof ProfileResponse>;

export const RefreshResponse = z.object({ success: z.literal(true) });
export type RefreshResponse = z.infer<typeof RefreshResponse>;

export const LogoutResponse = z.object({ success: z.literal(true), message: z.string() });
export type LogoutResponse = z.infer<typeof LogoutResponse>;

/** POST /api/auth/token: a Bearer token for command-line scripts. */
export const TokenResponse = z.object({ success: z.literal(true), token: z.string(), expiresAt: z.string() });
export type TokenResponse = z.infer<typeof TokenResponse>;
